import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-video-icon',
    templateUrl: './video-icon.component.html',
    styleUrls: ['./video-icon.component.scss'],
    standalone: false
})
export class VideoIconComponent implements OnInit, OnDestroy {
  param: any;
  check: any;
  UrlFeed: any;
  isShowClose: string;
  setClass: string;
  showLoading = true;

  private eventsSubscription: Subscription;

  @ViewChild('fileInput') fileInput: ElementRef;

  @Input() events: Observable<void>;
  @Input('VideoUrl') VideoUrl: any;
  @Input() isIconHide: boolean = false;
  @Input() href: any;

  constructor() {

  }

  ngOnInit() {
    this.showLoading = true;
    if (this.events) {
      this.eventsSubscription = this.events.subscribe(() => this.showVideo());
    }
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  close(value) {
    this.check = value;
    var iframe = document.querySelector('#myModal iframe') as HTMLIFrameElement;

    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;
      
    }
    else {
      iframe.src = 'https://www.youtube.com/embed/AIblq657VTg?list=PLugzlMICZR8h2n2KFLeVT_J6EURDNWb_O';
    }

  }

  afterHidden(value) {
    // your code here
    this.check = value;
    var iframe = document.querySelector('#myModal iframe') as HTMLIFrameElement;

    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;

    }
  }

  IsvideoActive(value) {
    this.check = value;
    var iframe = document.querySelector('iframe');
    this.setClass = iframe.src.indexOf('vimeo') > -1 ? 'video-height-vimeo' : 'video-height-youtube';

  }

  showVideo() {
    this.IsvideoActive(true);
    let inputElement: HTMLElement = this.fileInput.nativeElement as HTMLElement;
    inputElement.click();
  }
  showVideofromother(value) {
    this.check = value;
    var iframe = document.querySelector('iframe');
    this.setClass = iframe.src.indexOf('vimeo') > -1 ? 'video-height-vimeo' : 'video-height-youtube';
    let inputElement: HTMLElement = this.fileInput.nativeElement as HTMLElement;
    inputElement.click();

  }

  onLoad() {
    setTimeout(() => {
      this.showLoading = false;
  }, 2500);
    
  }

}



